import { useEffect, useState } from "react";
import ReactHtmlParser from "react-html-parser";
import { useSelector } from "react-redux";
import organizationClient from "@apis/organizationClient";
import SntWarning from "@cleanup/components/SntWarning";
import { useOrg } from "@/contexts/OrgContext";
import StringUtils from "@/utils/StringUtils";
import { RootState } from "@/types/RootState";
import { LanguageKey } from "@/types/generated/LanguageKey";
import { translate } from "@/hooks/useLanguage";

interface PagePermissionWarningProps {
  pageName?: string;
}

interface CheckPagePermissionResponse {
  orgName?: string;
  requiredFeatures?: string;
}

interface OrgContextType {
  orgId: number | null;
  updateOrg: (newOrgId: number) => void;
}

const PagePermissionWarning: React.FC<PagePermissionWarningProps> = ({
  pageName,
}) => {
  const orgContext = useOrg() as OrgContextType | null;
  const orgId = orgContext?.orgId;
  const loginInfo = useSelector((state: RootState) => state.user);

  const [orgName, setOrgName] = useState<string>();
  const [requiredFeatures, setRequiredFeatures] = useState<string[]>([]);
  const [showWarning, setShowWarning] = useState<boolean>(false);

  useEffect(() => {
    if (
      pageName &&
      loginInfo.organisation?.organisationType !== "NORMAL" &&
      orgId != null &&
      orgId !== 0
    ) {
      organizationClient
        .checkPagePermission({
          orgId: orgId,
          pageName: pageName,
        })
        .then(({ data }: { data: CheckPagePermissionResponse }) => {
          if (data.orgName) {
            setOrgName(data.orgName);
            setRequiredFeatures(
              data.requiredFeatures ? [data.requiredFeatures] : []
            );
            setShowWarning(true);
          } else {
            setShowWarning(false);
          }
        })
        .catch(() => {});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orgId]);

  return (
    <>
      {showWarning && (
        <div className="mt-2 mb-2">
          <SntWarning textClassName="d-flex justify-content-center">
            {ReactHtmlParser(
              translate(LanguageKey.organization_key) +
                " <b>" +
                orgName +
                "</b> " +
                translate(LanguageKey.has_no_access_to_feature) +
                (requiredFeatures && " <b>" + requiredFeatures + "</b>. ") +
                StringUtils.replaceStr(
                  translate(LanguageKey.change_for_this_org_to_enable_it),
                  ` <a href='/product_plan?org=${orgId}'>` +
                    translate(LanguageKey.platfrom_plan) +
                    "</a> "
                )
            )}
          </SntWarning>
        </div>
      )}
    </>
  );
};

export default PagePermissionWarning;
